import {
	ReactElement,
	useMemo
} from "react";
import {
	DateOnlyFormat,
	formatDateOnly
} from "client_legacy/ndaw/dateFormatting";
import { DateOnly } from "client/DateAndTime/dateOnly";

export type DateOnlyStringProps = {
	value: DateOnly;
	format: DateOnlyFormat;
};

export const DateOnlyString = (props: DateOnlyStringProps): ReactElement => {
	const {
		value,
		format
	} = props;

	const display: string = useMemo(
		(): string => {
			return formatDateOnly(
				value,
				format
			);
		},
		[format, value]
	);

	return (
		<>
			{ display }
		</>
	);
};
DateOnlyString.displayName = "DateOnlyString";
